import { QueryClientProvider } from '@tanstack/react-query';
import { createBrowserHistory } from 'history';
import { createRoot } from 'react-dom/client';
import { Router } from 'react-router-dom';
import { APIProvider } from '@vis.gl/react-google-maps';
import './index.css';
import { library } from '@fortawesome/fontawesome-svg-core';
import { fab } from '@fortawesome/free-brands-svg-icons';
import { far } from '@fortawesome/free-regular-svg-icons';
import { fas } from '@fortawesome/free-solid-svg-icons';
import { AuthHydrationGate } from '@/components/session/AuthHydrationGate';
import { SessionBootstrap } from '@/components/session/SessionBootstrap';
import { GOOGLE_MAPS_API_KEY, GOOGLE_MAPS_LIBRARIES } from '@/lib/google-maps';
import { createAppQueryClient } from '@/lib/query-client';
import { setupAxiosInterceptors } from '@/lib/setup-axios-interceptors';
import { useAuthStore } from '@/stores/auth-store';
import { useFestivalWorkspaceStore } from '@/stores/festival-workspace-store';
import App from './App';

library.add(far, fas, fab);

const basename = import.meta.env.BASE_URL.replace(/\/$/, '');
const history = createBrowserHistory({ basename });

const queryClient = createAppQueryClient();

setupAxiosInterceptors({
  queryClient,
  onUnauthorized: () => {
    useAuthStore.getState().clearSession();
    useFestivalWorkspaceStore.getState().clearFestivalWorkspace();
  },
});

const container = document.getElementById('root');
if (!container) {
  throw new Error('Missing #root element');
}
const root = createRoot(container);

root.render(
  <QueryClientProvider client={queryClient}>
    <APIProvider apiKey={GOOGLE_MAPS_API_KEY} libraries={GOOGLE_MAPS_LIBRARIES}>
      <Router history={history}>
        <AuthHydrationGate>
          <SessionBootstrap />
          <App />
        </AuthHydrationGate>
      </Router>
    </APIProvider>
  </QueryClientProvider>,
);
